// extracted by mini-css-extract-plugin
export default {"spark":"Spark1_spark__h77lH"};